export const PAGE_PERFORMANCE_DISPLAY_MODE = {
    NUMERIC: 'numeric',
    BINARY: 'binary',
    MANUAL: 'manual',
    INFORMATIVE: 'informative',
    NOT_APPLICABLE: 'notApplicable',
    METRIC_SAVINGS: 'metricSavings',
} as const;
